'use strict';

var processInclude = require('base/util');
const { queryFirst, removeClass, addClass, hasClass } = require('./domUtil');
const { INVISIBLE_CLASS, HIDDEN_CLASS } = require('./constants');

/**
 * Update Club Lilly page content visibility based on actual user authentication state
 * This runs on page load to override any cached content
 */
function updateClubLillyVisibility() {
    const categoryPage = queryFirst('.category-landing-page');
    if (!categoryPage) return;

    const clubLillyGuest = queryFirst('.club-lilly-guest');
    const clubLillyNonMember = queryFirst('.club-lilly-non-member');
    const clubLillyMember = queryFirst('.club-lilly-member');

    if (!clubLillyGuest && !clubLillyNonMember && !clubLillyMember) return;

    const profile = window.lillyUtils?.profile || {};
    const isAuthenticated = profile.isLoyaltyAuthenticated || false;
    const isMember = profile.isLoyaltyProgramMember || false;

    // Update the category-landing-page classes based on actual state
    if (isAuthenticated) {
        if (!hasClass(categoryPage, 'is-logged-in')) {
            addClass(categoryPage, 'is-logged-in');
        }
    } else {
        removeClass(categoryPage, 'is-logged-in');
    }

    if (isMember) {
        if (!hasClass(categoryPage, 'is-member')) {
            addClass(categoryPage, 'is-member');
        }
    } else {
        removeClass(categoryPage, 'is-member');
    }

    if (clubLillyGuest) {
        if (!isAuthenticated) {
            removeClass(clubLillyGuest, HIDDEN_CLASS);
        } else {
            addClass(clubLillyGuest, HIDDEN_CLASS);
        }
    }
    if (clubLillyNonMember) {
        if (isAuthenticated && !isMember) {
            removeClass(clubLillyNonMember, HIDDEN_CLASS);
        } else {
            addClass(clubLillyNonMember, HIDDEN_CLASS);
        }
    }
    if (clubLillyMember) {
        if (isAuthenticated && isMember) {
            removeClass(clubLillyMember, HIDDEN_CLASS);
        } else {
            addClass(clubLillyMember, HIDDEN_CLASS);
        }
    }
}

updateClubLillyVisibility();

document.addEventListener('DOMContentLoaded', () => {
    processInclude(require('./category/shopByStyle'));
    processInclude(require('./category/shopByPrint'));
    updateContentElements();
    updateClubLillyVisibility();
});

/**
 * This method updates the page H1 tag and banner header & text of the email capture asset for the seasonal pages.
 */
function updateContentElements() {
    const contentElement = queryFirst('.seasonal-landing-page');
    const headerElement = queryFirst('.dynamic-email-capture-title .plp-title');
    const bannerHeaderElement = queryFirst('.seasonal-banner-header', contentElement);
    const bannerTextElement = queryFirst('.seasonal-banner-title', contentElement);
    const categoryNameElement = queryFirst('.category-display-name');
    if (headerElement && bannerHeaderElement && bannerTextElement && categoryNameElement) {
        headerElement.innerHTML = categoryNameElement.value;
        bannerHeaderElement.innerHTML = categoryNameElement.value;
        bannerTextElement.innerHTML = categoryNameElement.value;
        removeClass(headerElement, INVISIBLE_CLASS);
        removeClass(bannerHeaderElement, INVISIBLE_CLASS);
        removeClass(bannerTextElement, INVISIBLE_CLASS);
    }
}
